import {SelectItem} from '@components/inputs/select/Select.component';
import {Array} from '@utils/extensions/array.extension';

export enum TableFilterType {
  SUPPLIER_ORGANISATION = 'SUPPLIER_ORGANISATION',
  EXCLUDE_SUPPLIER_ORGANISATION = 'EXCLUDE_SUPPLIER_ORGANISATION',
  SUPPLIER_ORGANISATION_UNIT = 'SUPPLIER_ORGANISATION_UNIT',
  EXCLUDE_SUPPLIER_ORGANISATION_UNIT = 'EXCLUDE_SUPPLIER_ORGANISATION_UNIT',
  CLIENT_ORGANISATION = 'CLIENT_ORGANISATION',
  EXCLUDE_CLIENT_ORGANISATION = 'EXCLUDE_CLIENT_ORGANISATION',
  CLIENT_ORGANISATION_UNIT = 'CLIENT_ORGANISATION_UNIT',
  EXCLUDE_CLIENT_ORGANISATION_UNIT = 'EXCLUDE_CLIENT_ORGANISATION_UNIT',
  SERVICE_KIND = 'SERVICE_KIND',
  EXCLUDE_SERVICE_KIND = 'EXCLUDE_SERVICE_KIND',
  WASTE = 'WASTE',
  EXCLUDE_WASTE = 'EXCLUDE_WASTE',
  WASTE_FAMILY = 'WASTE_FAMILY',
  EXCLUDE_WASTE_FAMILY = 'EXCLUDE_WASTE_FAMILY',
  CONTAINER = 'CONTAINER',
  EXCLUDE_CONTAINER = 'EXCLUDE_CONTAINER',
  ORGANISATION_TYPOLOGY = 'ORGANISATION_TYPOLOGY',
  ORGANISATION_DOMAIN = 'ORGANISATION_DOMAIN',
  CONTRACT = 'CONTRACT',
  STATUS = 'STATUS',
  CAN_BE_REQUESTED = 'CAN_BE_REQUESTED',
  TYPE_ACTION = 'TYPE_ACTION',
  USER = 'USER',
  SERVICE_KIND_TYPE = 'SERVICE_KIND_TYPE',
  EXCLUDE_SERVICE_KIND_TYPE = 'EXCLUDE_SERVICE_KIND_TYPE',
}

export namespace TableFilterType {
  export const initTableFilters = (types: TableFilterType[]): TableFilter[] =>
    types.map((type) => ({
      type,
      values: [],
    }));

  export const getRequestField = (type: TableFilterType) => {
    switch (type) {
      case TableFilterType.EXCLUDE_SUPPLIER_ORGANISATION:
        return 'excludeSupplierOrganisationIds';
      case TableFilterType.EXCLUDE_SUPPLIER_ORGANISATION_UNIT:
        return 'excludeSupplierOrganisationUnitIds';
      case TableFilterType.EXCLUDE_CLIENT_ORGANISATION:
        return 'excludeClientOrganisationIds';
      case TableFilterType.EXCLUDE_CLIENT_ORGANISATION_UNIT:
        return 'excludeClientOrganisationUnitIds';
      case TableFilterType.EXCLUDE_SERVICE_KIND:
        return 'excludeServiceKindIds';
      case TableFilterType.EXCLUDE_WASTE:
        return 'excludeWasteIds';
      case TableFilterType.EXCLUDE_WASTE_FAMILY:
        return 'excludeWasteFamilyIds';
      case TableFilterType.EXCLUDE_CONTAINER:
        return 'excludeContainerIds';
      case TableFilterType.EXCLUDE_SERVICE_KIND_TYPE:
        return 'excludeServiceKindTypes';
      case TableFilterType.SUPPLIER_ORGANISATION:
        return 'supplierOrganisationIds';
      case TableFilterType.SUPPLIER_ORGANISATION_UNIT:
        return 'supplierOrganisationUnitIds';
      case TableFilterType.CLIENT_ORGANISATION:
        return 'clientOrganisationIds';
      case TableFilterType.CLIENT_ORGANISATION_UNIT:
        return 'clientOrganisationUnitIds';
      case TableFilterType.SERVICE_KIND:
        return 'serviceKindIds';
      case TableFilterType.WASTE:
        return 'wasteIds';
      case TableFilterType.WASTE_FAMILY:
        return 'wasteFamilyIds';
      case TableFilterType.CONTAINER:
        return 'containerIds';
      case TableFilterType.ORGANISATION_TYPOLOGY:
        return 'typologiesFilter';
      case TableFilterType.ORGANISATION_DOMAIN:
        return 'domainsFilter';
      case TableFilterType.CONTRACT:
        return 'contractIds';
      case TableFilterType.STATUS:
        return 'status';
      case TableFilterType.CAN_BE_REQUESTED:
        return 'canBeRequested';
      case TableFilterType.TYPE_ACTION:
        return 'eventType';
      case TableFilterType.USER:
        return 'authorId';
      case TableFilterType.SERVICE_KIND_TYPE:
        return 'serviceKindTypes';
      default:
        return '';
    }
  };
}

export interface TableFilter {
  type: TableFilterType;
  values: SelectItem[];
  hide?: boolean;
  disabled?: boolean;
}

export namespace TableFilter {
  export const toRequestFilters = (filters: TableFilter[]) =>
    filters.reduce((filters, filter) => {
      return {
        ...filters,
        [TableFilterType.getRequestField(filter.type)]: Array.formatJson(
          Array.mapNotNull(filter.values?.map((v) => v.value))
        ),
      };
    }, {} as { [key: string]: string | undefined });
}
